module.exports = __webpack_public_path__ + "img/criterionimg6.b9007390.png";